"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isNumber = _interopRequireDefault(require("lodash/isNumber"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _dom = _interopRequireDefault(require("@spothero/utils/dom"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _RenderInBody = _interopRequireDefault(require("../RenderInBody/RenderInBody"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var Modal =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Modal, _PureComponent);

  function Modal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Modal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Modal).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onCloseClick", function (evt) {
      if (_this._isAnimating) {
        return;
      }

      var onCloseClick = _this.props.onCloseClick;

      _this.hide();

      if (onCloseClick) {
        onCloseClick();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onShimClick", function (evt) {
      var _this$props = _this.props,
          useShim = _this$props.useShim,
          closeOnShimClick = _this$props.closeOnShimClick;

      if (useShim && closeOnShimClick && _dom.default.hasClass(evt.target, 'Modal-wrapper')) {
        _this._onCloseClick();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onBackClick", function (evt) {
      _this.props.onRemoveIndex();
    });
    var _this$props2 = _this.props,
        width = _this$props2.width,
        title = _this$props2.title,
        onBeforeFirstRender = _this$props2.onBeforeFirstRender;
    _this._isDynamicWidth = (0, _isNumber.default)(width) || width.indexOf('%') > 0;
    _this._isAnimating = false;
    _this._isTitleString = title ? (0, _isString.default)(title) : false;
    _this._childHistory = [];

    if (onBeforeFirstRender) {
      onBeforeFirstRender();
    }

    return _this;
  }

  (0, _createClass2.default)(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var width = this.props.width;
      setTimeout(function () {
        // if ModalContent throws an error then the container will not be defined
        if (!_this2._container) {
          return;
        }

        if (_this2._isDynamicWidth) {
          var newWidth = (0, _isNumber.default)(width) ? "".concat(width, "px") // numerical width, set accordingly
          : width; // percentage width, retain and set

          _dom.default.addClass(_this2._container, 'Modal-container-custom');

          _this2._container.style.width = newWidth;
        }

        _this2._show();
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _dom.default.removeClass('html', 'Modal-open');
    }
  }, {
    key: "_show",
    value: function _show() {
      var _this3 = this;

      var _this$props3 = this.props,
          useShim = _this$props3.useShim,
          renderInBody = _this$props3.renderInBody,
          onShown = _this$props3.onShown,
          animateOnShow = _this$props3.animateOnShow;
      var node = useShim ? this._modal : this._container;
      var showClass = useShim ? 'Modal-showing' : 'Modal-container-showing';

      _dom.default.addClass(node, showClass);

      if (renderInBody) {
        _dom.default.addClass('html', 'Modal-open');
      }

      if (!useShim) {
        _dom.default.addClass(this._modal, 'Modal-no-shim');
      }

      if (animateOnShow) {
        this._isAnimating = true;
        window.transitionEnd(node).bind(function () {
          window.transitionEnd(node).unbind();

          if (onShown) {
            onShown();
          }

          _this3._isAnimating = false;
        });
      } else {
        if (onShown) {
          onShown();
        }
      }
    }
  }, {
    key: "_renderModal",
    value: function _renderModal() {
      var _this4 = this;

      var _this$props4 = this.props,
          className = _this$props4.className,
          renderInBody = _this$props4.renderInBody,
          useShim = _this$props4.useShim,
          title = _this$props4.title,
          showClose = _this$props4.showClose,
          children = _this$props4.children,
          width = _this$props4.width,
          animateOnShow = _this$props4.animateOnShow,
          activeContentIndex = _this$props4.activeContentIndex;
      var classes = (0, _classnames.default)('Modal', {
        'Modal-inline': !renderInBody
      }, {
        'Modal-animated': animateOnShow
      }, className);
      var containerClasses = (0, _classnames.default)('Modal-container', (0, _defineProperty2.default)({}, "Modal-container-".concat(width), !this._isDynamicWidth), {
        'Modal-container-animated': animateOnShow
      });
      return _react.default.createElement("div", {
        ref: function ref(node) {
          _this4._modal = node;
        },
        className: classes
      }, useShim && _react.default.createElement("div", {
        className: "Modal-shim"
      }), _react.default.createElement("div", {
        className: "Modal-wrapper",
        onClick: this._onShimClick
      }, _react.default.createElement("div", {
        ref: function ref(node) {
          _this4._container = node;
        },
        className: containerClasses
      }, title && _react.default.createElement("div", {
        className: "Modal-title"
      }, this._isTitleString ? _react.default.createElement("h1", null, title) : title), _react.default.createElement("div", {
        className: "Modal-ctas"
      }, showClose && _react.default.createElement(_Button.default, {
        className: "Modal-close",
        onClick: this._onCloseClick
      }, _react.default.createElement(_Icon.default, {
        name: "times"
      })), activeContentIndex > 0 && _react.default.createElement(_Button.default, {
        className: "Modal-back",
        onClick: this._onBackClick
      }, _react.default.createElement(_Icon.default, {
        name: "chevron-left"
      }))), children)));
    }
    /**
     * Hides the Modal programmatically.
     *
     * @public
     * @param {*} args - The arguments to pass to the onHidden callback in cases where you may need access to something not available in Modal itself.
     * @returns {void}
     */

  }, {
    key: "hide",
    value: function hide() {
      var _this5 = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this._isAnimating = true;
      var _this$props5 = this.props,
          useShim = _this$props5.useShim,
          renderInBody = _this$props5.renderInBody,
          onHidden = _this$props5.onHidden,
          animateOnShow = _this$props5.animateOnShow;
      var node = useShim ? this._modal : this._container;
      var showClass = useShim ? 'Modal-showing' : 'Modal-container-showing';

      if (!animateOnShow) {
        _dom.default.addClass(node, showClass.replace('showing', 'animated'));
      }

      if (!useShim) {
        _dom.default.removeClass(this._modal, 'Modal-no-shim');
      }

      _dom.default.removeClass(node, showClass);

      if (renderInBody) {
        _dom.default.removeClass('html', 'Modal-open');
      }

      window.transitionEnd(node).bind(function () {
        window.transitionEnd(node).unbind();
        _this5._isAnimating = false;

        if (!animateOnShow) {
          _dom.default.removeClass(node, "".concat(showClass, "-animated"));
        }

        if (onHidden) {
          onHidden.apply(void 0, args);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          renderInBody = _this$props6.renderInBody,
          store = _this$props6.store;

      if (renderInBody) {
        return _react.default.createElement(_RenderInBody.default, {
          store: store
        }, this._renderModal());
      } else {
        return this._renderModal();
      }
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return Modal;
}(_react.PureComponent);

exports.default = Modal;
(0, _defineProperty2.default)(Modal, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** Whether to render the modal to the body tag (otherwise renders to current position in DOM). */
  renderInBody: _propTypes.default.bool,

  /** Whether to use the background shim. */
  useShim: _propTypes.default.bool,

  /** Whether to show the close button. */
  showClose: _propTypes.default.bool,

  /** Whether to animate the Modal showing. */
  animateOnShow: _propTypes.default.bool,

  /** Whether to close the Modal when the shim is clicked. */
  closeOnShimClick: _propTypes.default.bool,

  /** The title of the modal. If one isn't provided then the title won't render. */
  title: _propTypes.default.node,

  /** The width of the modal. (size string, pixel value [integer] or percentage ["100%"]) */
  width: _propTypes.default.oneOfType([_propTypes.default.oneOf(['extra-slim', 'slim', 'normal', 'wide', 'extra-wide']), _propTypes.default.number, _propTypes.default.string]),

  /** A function to execute after the modal has been shown. */
  onShown: _propTypes.default.func,

  /**
   * A function to execute after the modal has been hidden. Use this to manage state in a parent component to remove the modal from the DOM (see examples).
   *
   * @param {*} args - Any arguments that were passed to `hide()` to retrieve in the callback.
   */
  onHidden: _propTypes.default.func,

  /** A function to execute when the close button or the shim is clicked. */
  onCloseClick: _propTypes.default.func,

  /** Markup to pass as children to the modal. Pass either one element or an array of elements. */
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.arrayOf(_propTypes.default.element), _propTypes.default.node]).isRequired,

  /** Indicates the current index of the content being displayed. Manage this from the ModalContent (see examples) and in the parent component's state. */
  activeContentIndex: _propTypes.default.number,

  /** A function to execute that helps manage state in a parent component to determine which ModalContent to show. Required when multiple ModalContents are present in the parent. */
  onRemoveIndex: _propTypes.default.func,

  /** Optional Redux store to pass into the rendered Modal. Required if the Modal uses any data or actions from a Redux store. */
  store: _propTypes.default.object,

  /** A function to execute at the end of the constructor before the Modal is rendered. */
  onBeforeFirstRender: _propTypes.default.func
});
(0, _defineProperty2.default)(Modal, "defaultProps", {
  renderInBody: true,
  useShim: true,
  showClose: true,
  width: 'normal',
  activeContentIndex: 0,
  closeOnShimClick: true,
  animateOnShow: true
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Modal, "Modal", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Modal/Modal.jsx");
  leaveModule(module);
})();

;